import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Instance Axios
const api: AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token JWT
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Essayer d'abord le token classique (pour cybers/admins connectés normalement)
    let token = localStorage.getItem('token');
    console.log('[API Interceptor] Token from "token":', token ? 'Found' : 'Not found');

    // Si pas de token classique, essayer le clientAccessToken (pour cybers connectés via PWA)
    if (!token) {
      token = localStorage.getItem('clientAccessToken');
      console.log('[API Interceptor] Token from "clientAccessToken":', token ? 'Found' : 'Not found');
    }

    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('[API Interceptor] Authorization header set for:', config.url);
    } else {
      console.warn('[API Interceptor] NO TOKEN FOUND for:', config.url);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
